import type { InjectionKey, Ref } from 'vue'
import type {
  ScopedSetting,
  SettingName,
  TypedSettingValues
} from '../Settings'

export interface AgencySettingsService {
  agencyId: Ref<string | undefined>
  scopedSettings: Record<SettingName, ScopedSetting<SettingName> | undefined>
  isLoading: Ref<boolean>
  refetch: (settingNames?: readonly SettingName[]) => Promise<void>
  upsert: <TName extends SettingName>(
    settingName: TName,
    value: TypedSettingValues[TName],
    settingVersion?: number
  ) => Promise<void>
  remove: (settingName: SettingName) => Promise<void>
  get: (settingName: SettingName) => ScopedSetting<SettingName> | undefined
}

export const agencySettingsKey = Symbol(
  'gs-agency-settings'
) as InjectionKey<AgencySettingsService>
